import { MindbodyUser } from './client';

export interface MindbodyClass {
  WaitListSize: number;
  ClassScheduleId: number;
  Visits: null | number;
  // Clients: [],
  Location: {
    AdditionalImageURLs: null;
    Address: string;
    Address2: string;
    Amenities: { Id: number; Name: string }[];
    BusinessDescription: null;
    City: string;
    Description: null;
    HasClasses: boolean;
    Id: 1;
    Latitude: number;
    Longitude: number;
    Name: string;
    Phone: string;
    PhoneExtension: null;
    PostalCode: string;
    SiteID: number;
    StateProvCode: string;
    Tax1: number;
    Tax2: number;
    Tax3: number;
    Tax4: number;
    Tax5: number;
    TotalNumberOfRatings: number;
    AverageRating: number;
    TotalNumberOfDeals: number;
  };
  Resource: {
    Id: number;
    Name: string;
  };
  MaxCapacity: number;
  WebCapacity: number;
  TotalBooked: number;
  TotalSignedIn: number;
  TotalBookedWaitlist: number;
  WebBooked: number;
  SemesterId: null | number;
  IsCanceled: boolean;
  Substitute: boolean;
  Active: boolean;
  IsWaitlistAvailable: boolean;
  IsEnrolled: null | boolean;
  HideCancel: boolean;
  Id: number;
  IsAvailable: boolean;
  StartDateTime: string;
  EndDateTime: string;
  LastModifiedDateTime: string;
  ClassDescription: {
    Active: boolean;
    Description: string;
    Id: number;
    ImageURL: string;
    LastUpdated: string;
    Level: {
      Id: number;
      Name: string;
      Description: null | string;
    };
    Name: string;
    Notes: string;
    Prereq: string;
    Program: {
      Id: number;
      Name: string;
      ScheduleType: string;
      CancelOffset: number;
      ContentFormats: string[];
      PricingRelationships: null;
    };
    SessionType: {
      Type: string;
      DefaultTimeLength: null;
      StaffTimeLength: null;
      Id: number;
      Name: string;
      NumDeducted: number;
      ProgramId: number;
    };
    Category: null;
    CategoryId: null;
    Subcategory: null;
    SubcategoryId: null;
  };
  Staff: {
    Address: string;
    AppointmentInstructor: boolean;
    AlwaysAllowDoubleBooking: boolean;
    Bio: string;
    City: string;
    Country: string;
    Email: null;
    FirstName: string;
    DisplayName: string;
    HomePhone: string;
    Id: number;
    IndependentContractor: boolean;
    IsMale: boolean;
    LastName: string;
    MobilePhone: null;
    Name: string;
    PostalCode: string;
    ClassTeacher: boolean;
    SortOrder: 0;
    State: string;
    WorkPhone: null;
    ImageUrl: null;
    ClassAssistant: boolean;
    ClassAssistant2: boolean;
    EmploymentStart: null;
    EmploymentEnd: null;
    ProviderIDs: null;
    Rep: boolean;
    Rep2: boolean;
    Rep3: boolean;
    Rep4: boolean;
    Rep5: boolean;
    Rep6: boolean;
    StaffSettings: {
      UseStaffNicknames: boolean;
      ShowStaffLastNamesOnSchedules: boolean;
    };
    Appointments: [];
    Unavailabilities: [];
    Availabilities: [];
    EmpID: null;
  };
  BookingWindow: {
    StartDateTime: string;
    EndDateTime: string;
    DailyStartTime: null;
    DailyEndTime: null;
  };
  BookingStatus: string;
  VirtualStreamLink: null;
  PickASpot: PickaspotClass;
}

export enum MindbodyPickASpotClassCellContent {
  Empty = 'Empty',
  Other = 'Other',
  Spot = 'Spot',
  Instructor = 'Instructor',
}
export interface MindbodyPickASpotClassCell {
  row: number;
  column: number;
  cellContent: MindbodyPickASpotClassCellContent;
  iconId?: string;
  spot: {
    spotNumber: number;
    spotAlias: string;
    isAvailable: boolean;
  };
}

export interface PickaspotClass {
  classEndTime: string;
  classExternalId: string;
  classId: string;
  classMaximumCapacity: number;
  className: string;
  classStartTime: string;
  locationId: number;
  reservations: PickaspotReservation[];
  roomId: string;
  roomLayout: {
    roomLayoutId: string;
    roomLayoutName: string;
    roomLayoutDescription: string;
    maxCapacity: number;
    groups: [];
    roomLayoutGrid: {
      rows: number;
      columns: number;
      cells: MindbodyPickASpotClassCell[];
    };
  };
  siteId: number;
  spots: {
    reservedSpotNumbers: number[];
    availableSpotNumbers: number[];
    unavailableSpotNumbers: number[];
  };
}

export interface PickaspotReservation {
  reservationId: string;
  reservationExternalId: string;
  classId: string;
  classExternalId: string;
  memberExternalId: string;
  reservationType: string;
  spot: {
    spotNumber: number;
    spotAlias: string;
    iconSourceFile: string;
  };
  isConfirmed: boolean;
  expirationDate: string;
}

export interface MindbodyWaitlistEntry {
  ClassDate: Date;
  ClassId: number;
  Client: MindbodyUser;
  EnrollmentDateForward: Date;
  Id: number;
  RequestDateTime: Date;
  VisitRefNo: number;
  Web: boolean;
}
